import api from "services/api";

// Get all designations
export const getDesignations = async () => {
  return api.get("/v1/api/designations/list");
};

// Create designation
export const createDesignation = async (designationData) => {
  return api.post("/v1/api/designations/create", designationData);
};

// Update designation status (active/inactive)
export const updateDesignationStatus = async (id, status) => {
  return api.put("/v1/api/designations/status", { id, status });
};

// Update designation
export const updateDesignation = async (id, designationData) => {
  return api.put(`/v1/api/designations/update/${id}`, designationData);
};
